<template>
  <adminTable
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <!-- <el-form-item>
        <el-input
          v-model="searchForm.username"
          placeholder="请输入用户名"
          clearable
        />
      </el-form-item> -->
      <el-form-item>
        <el-input
          v-model="searchForm.uid"
          placeholder="请输入用户ID"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.phone"
          placeholder="请输入手机号码"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.is_test"
          placeholder="账号类型"
          clearable
        >
          <el-option
            v-for="item in accountTypeEnums"
            :label="item.label"
            :value="item.value"
            :key="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.class_id"
          placeholder="流水类型"
          clearable
          filterable
        >
          <el-option
            v-for="item in fundingTypeList"
            :label="item.title"
            :value="item.id"
            :key="item.title"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-col :span="11">
          <el-date-picker
            v-model="searchForm.starttime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="开始时间"
            style="width: 100%"
          />
        </el-col>
        <el-col :span="2" class="text-center">
          <span class="text-gray-500">-</span>
        </el-col>
        <el-col :span="11">
          <el-date-picker
            v-model="searchForm.endtime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="结束时间"
            style="width: 100%"
          />
        </el-col>
      </el-form-item>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="username" label="用户名" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ scope.row?.username || '--' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号码" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ scope.row?.phone || '--' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="is_test" label="用户类型" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ getLabelByVal(scope.row?.is_test, accountTypeEnums) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="数量" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ scope.row?.amount || 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="can_be" label="消耗可提" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ scope.row?.can_be || 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="before" label="变化前" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ scope.row?.before || 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="after" label="变化后" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ scope.row?.after || 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="class_name" label="类型" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ scope.row?.class_name || '--' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="说明" width="180">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ scope.row?.desc || '--' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="create_at" label="添加时间" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row?.is_test == 1 ? 'red' : '' }">
            {{ scope.row?.create_at || '--' }}
          </span>
        </template>
      </el-table-column>
    </template>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted, watch } from "vue";
import { accountTypeEnums, getLabelByVal } from "../../config/enums";
const props = defineProps({
  phone: { type: String, default: "" }
});
const searchForm = ref({
  uid: "",
  username: "",
  phone: "",
  is_test: "",
  class_id: "",
  starttime: "",
  endtime: "",
});
onMounted(() => {
  getList();
  getFundingList()
});

const fundingTypeList = ref([])
const getFundingList = async () => {
  const res = await proxy.$http({
    method: 'get',
    url: 'money/getMoneyClassLists'
  })
  if (res.code == 0) {
    fundingTypeList.value = res.data.sort((a, b) => (a.id === 37 ? -1 : b.id === 37 ? 1 : 0));
  }
}

const { proxy } = getCurrentInstance();

const tableData = ref([]);

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);

const getList = async () => {
    tableLoading.value = true;
  const res = await proxy.$http({
    method: "get",
    url: "/MoneyLog/getMoneyLogLists",
    params: {
      page: page.value,
      limit: limit.value,
      ...searchForm.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total; 
  }
};
// 监听phone传入（实际传的是用户ID）
watch(
  () => props.phone,
  (val) => {
    if (val) {
      searchForm.value.uid = val; // 赋值到id搜索框
    }
  },
  { immediate: true }
);
</script>

<style lang="less" scoped></style>
